import { render, staticRenderFns } from "./MtrlEditMain.vue?vue&type=template&id=7560036e&scoped=true&"
import script from "./MtrlEditMain.vue?vue&type=script&lang=js&"
export * from "./MtrlEditMain.vue?vue&type=script&lang=js&"
import style0 from "./MtrlEditMain.vue?vue&type=style&index=0&id=7560036e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7560036e",
  null
  
)

export default component.exports